import React, { Component } from 'react'
import { KeyValue } from '../types'

interface Props {
  value?: string
  keyValue?: KeyValue
  icon?: any
  onClick?: (value?: KeyValue) => void
  style?: any
}

export default class TextInput extends Component<Props> {
  render() {
    const { value, keyValue, icon, onClick, style } = this.props
    const label = value ?? keyValue?.value
    return (
      <button className="sq-tab" onClick={() => onClick && onClick(keyValue)} style={style} type="button">
        {icon && <img src={icon} alt="" className="sq-tab__icon"></img>}
        {label}
      </button>
    )
  }
}
